import { FETCH_ORDERS_BY_STATUS_COUNT_REQUEST, FETCH_ORDERS_BY_STATUS_COUNT_SUCCESS, FETCH_ORDERS_BY_STATUS_COUNT_FAILURE, FETCH_ORDERS_BY_STATUS_COUNT_RESET, } from "../../actions";
const initialState = {
    fetchOrdersCount: null,
    isLoading: false,
    error: null,
};
const OrderByStatusCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDERS_BY_STATUS_COUNT_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case FETCH_ORDERS_BY_STATUS_COUNT_SUCCESS:
            return Object.assign(Object.assign({}, state), { fetchOrdersCount: action.payload, isLoading: false, error: null });
        case FETCH_ORDERS_BY_STATUS_COUNT_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case FETCH_ORDERS_BY_STATUS_COUNT_RESET:
            return initialState;
        default:
            return state;
    }
};
export default OrderByStatusCountReducer;
